// ** Third Party
import Proptypes from "prop-types";
// ** Reactstrap
import { Alert, UncontrolledAlert } from "reactstrap";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

const CustomAlerts = props => {
    const {
        title = "",
        color = "warning",
        body,
        className = "mt-0 mb-75",
        controlled = false,
        alertBodyClass = "",
        hide = false,
        testId = ""
    } = props;
    const { t } = useTranslation();
    const TagName = controlled ? Alert : UncontrolledAlert;
    return !hide ? (
        <TagName color={color} className={className} data-cy={testId}>
            {title && <h4 className="alert-heading">{t(title)}</h4>}
            <div className={classnames("alert-body", alertBodyClass)}>
                {typeof body === "string" ? t(body) : body}
            </div>
        </TagName>
    ) : null;
};

export default CustomAlerts;

CustomAlerts.propTypes = {
    color         : Proptypes.string,
    body          : Proptypes.any.isRequired,
    title         : Proptypes.string,
    controlled    : Proptypes.bool,
    className     : Proptypes.string,
    alertBodyClass: Proptypes.string,
    hide          : Proptypes.bool,
    testId        : Proptypes.string
};
